/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { DeviceService } from '@hems/service/src/api/device/DeviceService';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class DeviceServiceAdmin extends DeviceService {
    constructor(axios) {
        super(axios);
    }
    /** Site 삭제 */
    deleteSite = async (siteId) => {
        const { status } = await this.deleteNew(apiWrapper.managerApiV1(`/sites/${siteId}`));
        return status;
    };
}
